import { BaseModel } from "../../Bases/BaseModel";

export class UsuarioNaoConformidade extends BaseModel {
  constructor(
    public usuario_id = 0,
    public nao_conformidade_id = 0,
    public nao_conformidade_nome = ''

  ) {
    super();
  }
}


